import React, { Fragment, createContext, useState, useMemo } from 'react';
import { BrowserRouter, Routes, Route, Link as RouterLink } from 'react-router-dom';
import Dashboard from './pages/dashboard/Dashboard';
import PersonnelDetail from './pages/personnelDetail/PersonnelDetail';
import UserChangeInfo from './pages/userChangeInfo/UserChangeInfo';
import GlobalMenu from './components/GlobalMenu/GlobalMenu';
import RecruitmentDetailPage from './pages/recruitmentDetail/RecruitmentDetailPage';
import AdminManagementPage from './pages/adminManagement/AdminManagementPage';
import AdminChangeUserInfo from './pages/adminManagement/components/templates/AdminChangeUserInfo';
import Login from './pages/login/Login';
import NotFound from './pages/notFound/NotFound';
import RedirectPage from './pages/redirect/RedirectPage';
import UserRegisterPage from './pages/userRegister/UserRegisterPage';
import RecruitmentListPage from './pages/recruitmentList/RecruitmentListPage';
import PersonnelListPage from './pages/personnelList/PersonnelListPage';
import NotificationHistory from './pages/notificationHistory/NotificationHIstory';
import RecruitmentRgistationPage from './pages/recruitmentRegistration/RecruitmentRegistationPage';
import RecruitmentRegistationSample from './pages/recruitmentRegistationSample/recruitmentRegistrationSample';
import EditPassword from './pages/editPassword/editPassword';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { themeOptions } from './style/themeOptions';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import Link from '@mui/material/Link';

interface GlobalContextType {
  rerendering: boolean;
  setRerendering: React.Dispatch<React.SetStateAction<boolean>>;
}

function MyFallbackComponent() {
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <h2>Not Found Page</h2>
      <h3>
        ログインは
        <Link component={RouterLink} to="/">
          こちら
        </Link>
        から
      </h3>
    </Box>
  );
}
export const globalContext = createContext<GlobalContextType>({
  rerendering: false,
  setRerendering: () => {},
});

const apptheme = createTheme(themeOptions);

export default function App() {
  const [rerendering, setRerendering] = useState<boolean>(false);
  const contextValues = useMemo(() => ({ rerendering, setRerendering }), [rerendering]);

  return (
    <Fragment>
      <globalContext.Provider value={contextValues}>
        <ThemeProvider theme={apptheme}>
          <Box sx={{ bgcolor: '#F2F3F4' }}>
            <BrowserRouter>
              <Box
                sx={{
                  maxWidth: '1000px',
                  '@media screen and (min-width:1080px)': {
                    mx: 'auto',
                  },
                  mx: '10px',
                  py: '15px',
                  minHeight: '600px',
                }}
              >
                <ErrorBoundary FallbackComponent={MyFallbackComponent}>
                  <Routes>
                    {/** ログイン画面 */}
                    <Route path="/" element={<Login />} />
                    <Route
                      path="/projectRegister/sample"
                      element={<RecruitmentRegistationSample />}
                    />
                    <Route path="/" element={<GlobalMenu />}>
                      {/** ダッシュボード */}
                      <Route path="/dashboard/" element={<Dashboard />} />
                      {/** お知らせ履歴 */}
                      <Route
                        path="/dashboard/notification"
                        element={<NotificationHistory />}
                      />
                      {/** 要員一覧 */}
                      <Route
                        path="/personnelListPage/"
                        element={<PersonnelListPage />}
                      />
                      {/** 募集一覧 */}
                      <Route
                        path="/recruitmentListPage/"
                        element={<RecruitmentListPage />}
                      />
                      {/** 要員詳細 */}
                      <Route
                        path="/personnelDetail/"
                        element={<PersonnelDetail />}
                      />
                      {/** 募集詳細 */}
                      <Route
                        path="/recruitmentDetail/"
                        element={<RecruitmentDetailPage />}
                      />
                      {/** ユーザ情報 */}
                      <Route
                        path="/userChangeInfo"
                        element={<UserChangeInfo />}
                      />
                      {/** 管理メニュー(管理者のみ) */}
                      <Route
                        path="/adminManagement/"
                        element={<AdminManagementPage />}
                      />
                      {/** ユーザ管理(追加)画面 */}
                      <Route
                        path="/adminManagement/userRegister"
                        element={<UserRegisterPage />}
                      />
                      {/** 募集登録画面 */}
                      <Route
                        path="/projectRegister"
                        element={<RecruitmentRgistationPage />}
                      />
                      {/** BP管理者からのユーザ詳細画面 */}
                      <Route
                        path="/adminManagement/adminChangeUserInfo"
                        element={<AdminChangeUserInfo />}
                      />
                      {/** パスワード変更画面 */}
                      <Route path="/editPassword" element={<EditPassword />} />
                      {/** ログイン確認のためのリダイレクト画面 */}
                      <Route path="/direct" element={<RedirectPage />} />
                    </Route>
                    {/** Not Foundページ */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </ErrorBoundary>
              </Box>
            </BrowserRouter>
            <Box>
              <Typography
                sx={{
                  height: '40px',
                  bgcolor: '#fff',
                  lineHeight: '40px',
                  color: '#9e9e9e',
                  fontSize: '8px',
                  textAlign: 'center',
                }}
              >
                ©︎{new Date().getFullYear()} rexcornu, Inc. All right Reserved
              </Typography>
            </Box>
          </Box>
        </ThemeProvider>
      </globalContext.Provider>
    </Fragment>
  );
}
